<template>
    <el-dialog
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible">
        <el-form :model="dataForm" :rules="rules" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="160px">
            <el-form-item label="用户名" prop="userName">
                <el-input v-model="dataForm.userName" placeholder="用户名"></el-input>
            </el-form-item>
            <el-form-item label="真实姓名" prop="realName">
                <el-input v-model="dataForm.realName" placeholder="真实姓名"></el-input>
            </el-form-item>
            <el-form-item label="身份证编号" prop="idNo">
                <el-input v-model="dataForm.idNo" placeholder="身份证编号"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" v-if="!dataForm.mobile" prop="mobile">
                <el-input v-model="dataForm.mobile" placeholder="手机号码"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" v-else prop="mobile">
                <span>{{dataForm.mobile}}</span>
            </el-form-item>
            <el-form-item label="座机号码" prop="realName">
                <el-input v-model="dataForm.telphone" placeholder="座机号码"></el-input>
            </el-form-item>
            <el-form-item label="邮箱地址" prop="email">
                <el-input v-model="dataForm.email" placeholder="描述"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    export default {
        props: ['mainContentViewHeight'],
        data() {
            return {
                visible: false,
                dataForm: {
                    id: '',
                    orgId: '',
                    deptId: '',
                    idNo: '',
                    userName: '',
                    realName: '',
                    mobile: '',
                    email: '',
                    hrLevel: 1,
                    userCode: '',
                    description: '',
                },
                rules: {
                    userName: [
                        {required: true, message: '请输入用户名', trigger: 'blur'},
                    ],
                    mobile: [
                        {required: true, message: '请输入手机号码', trigger: 'blur'},
                    ]
                }
            }
        },
        methods: {
            init( id) {
                this.dataForm.id = id || ''
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields();
                })
                this.visible = true
                this.$http({
                    url: '/auth/employee/get?id=' + this.dataForm.id,
                    method: 'post'
                }).then(({data}) => {
                    if (data && data.code === '1') {
                        this.dataForm = data.data
                    } else {
                    }
                })
            },
            resetForm() {
                this.$refs['dataForm'].resetFields();
            },
            // 表单提交
            dataFormSubmit() {
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return
                    }
                })
                this.saveHandler()
            },
            // 表单提交
            saveHandler() {
                this.$http({
                    url: '/auth/employee/saveorupdate',
                    method: 'post',
                    data: this.dataForm
                }).then(({data}) => {
                    if (data && data.code === '1') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            }
        }
    }
</script>
